import { createContext } from 'react'

import { useContextSafely } from './useContextSafely'

export const RootNodeContext = createContext<HTMLElement | null>(null)

export function useRootNode() {
    return useContextSafely(RootNodeContext, 'RootNode')
}
